import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { OarStatementContent } from '../types/oar-statement-types';

/**
 * OAR 陈述书内容模型接口
 *
 * 用于管理 OAR 任务中陈述书和对照页的内容数据，包括：
 * - 陈述书正文内容
 * - 权利要求对照页内容
 * - 说明书对照页内容
 * - 生成时间戳和统计信息
 */
export interface OarStatementContentModel extends Model<OarStatementContent>, Disposable {}

/**
 * OAR 陈述书内容模型依赖注入符号
 */
export const OarStatementContentModel = Symbol.for('OarStatementContentModel');
